<template>
  <div v-show="isLoaded" class="mBannerRed-container" v-observe-visibility="startAnimate">
    <img class="mBannerRed-image" :src="banner" alt="BannerRed">
    <img class="mBannerRed-image-desktop" :src="banner_desktop" alt="BannerRed">
    <div class="mBannerRed-title-container">
      <h1 class="mBannerRed-title" :class="{animate: animate}">
        StrongBow
      </h1>
      <h2 class="mBannerRed-subtitle" :class="{animate: animate}">
        Red Berries
      </h2>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/red-berries/red_berries.jpg';
import banner_desktop from '@/assets/red-berries/banner_desktop.png';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "BannerRed",
  data() {
    return {
      banner,
      banner_desktop,
      animate: false,
      isSafari: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RedBerries/BannerRed.scss";
</style>